import { makeStyles, createStyles } from '@material-ui/core/styles';

interface BackdropStylesProps {
  backdropColor?: string;
}

export const BackdropStyles = makeStyles(() =>
  createStyles({
    backdropBgColor: (props: BackdropStylesProps) => ({
      backgroundColor: props.backdropColor,
      zIndex: 9,
    }),
  }),
);
